module.exports = __webpack_public_path__ + "a7039452d60397daf6816880c10cb260.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.html
// module id = 2030
// module chunks = 0